import "./index.scss";

import { Box } from "@mui/material";
import CheckableButton from "components/CheckableButton";
import SearchBar from "components/SearchBar";
import React, { FC, memo, useState } from "react";

type selectedValueType = string | number;
type selectedValuesTypes = selectedValueType[];

export type TSearchableItem = {
  label: string;
  image?: string;
  value?: selectedValueType;
};

interface SearchableListProps {
  options: TSearchableItem[];
  hasImage?: boolean;
  className?: string;
  callback?: Function;
  preselectedValues?: selectedValuesTypes;
  isMultiple?: boolean;
}

const SearchableList: FC<SearchableListProps> = (props) => {
  const {
    options = [],
    preselectedValues,
    hasImage,
    className,
    callback,
    isMultiple = true,
  } = props;

  const [searchStr, setSearchStr] = useState("");
  let optionsWithValues = [];
  optionsWithValues = options.map((e) => {
    if (typeof e.value !== "number" && !e.value) {
      e.value = e.label;
    }
    return e;
  });
  const [filterOptions, setFilterOptions] = useState(optionsWithValues);
  const [selectedValues, setSelectedValues] = useState<selectedValuesTypes>(
    preselectedValues || []
  );

  const handleSearch = (str: string) => {
    setFilterOptions([...options.filter((x) => x.label.toLowerCase().includes(str.toLowerCase()))]);
    setSearchStr(str);
  };

  const handlePressItem = (e: React.MouseEvent, value: selectedValueType) => {
    e.preventDefault();
    let arrayToReturnToCallback = [];
    if (isMultiple) {
      const existIndex = selectedValues.findIndex((x) => x === value);
      if (existIndex > -1) {
        setSelectedValues([...selectedValues.filter((x: selectedValueType) => x !== value)]);
        arrayToReturnToCallback = [...selectedValues.filter((x: selectedValueType) => x !== value)];
      } else {
        setSelectedValues([...selectedValues, value]);
        arrayToReturnToCallback = [...selectedValues, value];
      }
    } else {
      setSelectedValues([value]);
      arrayToReturnToCallback = [value];
    }
    if (callback) {
      callback(arrayToReturnToCallback);
    }
  };

  return (
    <Box className={`searchable-list-container ${className || ""}`}>
      <Box className="header">
        <SearchBar className="search-bar" value={searchStr} onSearch={handleSearch} />
      </Box>
      <Box className="list">
        {filterOptions.map((item, index) => (
          <CheckableButton
            key={index}
            hasImage={hasImage}
            name={item.label}
            image={item.image}
            active={selectedValues.findIndex((x) => x === item.value) > -1}
            onClick={(e) => handlePressItem(e, item.value)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default memo(SearchableList);
